import { Dimensions } from 'components/insights/constants';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { defaultFilterDropdownConfig } from 'constants/filterConfigs';
import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { GroupAccessMode, useInfiniteGroups } from 'services/api/group';

// The receiving-SNF filter. Inbound referrals are only eligible for SNF groups, so scope options
// to the SNF group type (not all providers/LTC) among the groups the user can access. The backend
// facility dimension filters on workflow_groups.group_id, so the group id is the filter value.
export const SNF_DROPDOWN = {
  ...defaultFilterDropdownConfig,
  placeholder: 'SNF',
  name: Dimensions.FACILITY,
  getOptions: {
    hook: useInfiniteGroups,
    params: { sortBy: 'name asc', type: SKILLED_NURSING_FACILITY, accessModes: [GroupAccessMode.Allowed] },
  },
};

export const getFilterSections = (): FilterSection[] => [{ filters: [SNF_DROPDOWN] }];
